import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Mail, MapPin, Phone, Instagram, Music2 } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", form);
      toast.success("Message received. We'll be in touch within 24 hours.");
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.error("Could not send. Please try again or DM us on Instagram.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-[#FFF4E0] min-h-screen" data-testid="contact-page">
      <section className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-20 md:py-28 grid grid-cols-1 lg:grid-cols-2 gap-16">
        <div>
          <div className="overline mb-3">Concierge</div>
          <h1 className="font-serif-display text-5xl md:text-7xl text-[#1A0F11]">Let&apos;s talk.</h1>
          <p className="text-[#5C4A4D] mt-6 max-w-md">Personal styling consults, bespoke orders, salon partnerships — our concierge replies within 24 hours.</p>

          <div className="mt-12 space-y-6">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 bg-[#831132] text-[#FFF4E0] flex items-center justify-center"><Mail size={16}/></div>
              <div>
                <div className="overline">Email</div>
                <a href="mailto:hello@thehairbutik.com" className="text-[#1A0F11] hover:text-[#831132]">hello@thehairbutik.com</a>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 bg-[#831132] text-[#FFF4E0] flex items-center justify-center"><Phone size={16}/></div>
              <div>
                <div className="overline">WhatsApp</div>
                <a href="https://wa.me/447979140513" className="text-[#1A0F11] hover:text-[#831132]" data-testid="contact-whatsapp">Chat with us on WhatsApp · +44 7979 140513</a>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 bg-[#831132] text-[#FFF4E0] flex items-center justify-center"><MapPin size={16}/></div>
              <div>
                <div className="overline">House Address</div>
                <div className="text-[#1A0F11]">5 Bradford Square<br/>London E1 0SG<br/>England</div>
              </div>
            </div>
          </div>

          <div className="mt-10 flex items-center gap-4">
            <a href="https://instagram.com/thehairbutik" target="_blank" rel="noreferrer" className="w-10 h-10 bg-[#1A0F11] text-[#FFF4E0] flex items-center justify-center hover:bg-[#831132]" data-testid="contact-instagram"><Instagram size={16}/></a>
            <a href="https://tiktok.com/@thehairbutik" target="_blank" rel="noreferrer" className="w-10 h-10 bg-[#1A0F11] text-[#FFF4E0] flex items-center justify-center hover:bg-[#831132]" data-testid="contact-tiktok"><Music2 size={16}/></a>
          </div>
        </div>

        <form onSubmit={submit} className="bg-[#FDF1EC] p-8 md:p-12 space-y-6" data-testid="contact-form">
          <div>
            <div className="label-luxe">Your name</div>
            <input required value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} className="input-luxe" data-testid="contact-name"/>
          </div>
          <div>
            <div className="label-luxe">Email</div>
            <input required type="email" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} className="input-luxe" data-testid="contact-email"/>
          </div>
          <div>
            <div className="label-luxe">Message</div>
            <textarea required rows={6} value={form.message} onChange={(e) => setForm({...form, message: e.target.value})} className="input-luxe resize-none" data-testid="contact-message"/>
          </div>
          <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="contact-submit">{loading ? "Sending..." : "Send Message"}</button>
        </form>
      </section>
    </div>
  );
}
